import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { forkJoin, switchMap } from 'rxjs';
import { FunctionsService } from 'src/app/services/api/functions.service';
import Swal from 'sweetalert2';
import { FileModel } from 'src/app/model/file/model.file';
import { FileService } from 'src/app/services/api/file.service';
import { LoadingService } from 'src/app/services/loading.service';
import { DialogArchivosReservasComponent } from 'src/app/file/services/dialog-archivos-reservas/dialog-archivos-reservas.component';

import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { DialogPdfComponent } from 'src/app/programacion-aventura/dialog-pdf/dialog-pdf.component';
import { CognitoService } from 'src/app/services/cognito.service';
import { hasServiceOrder } from 'src/entities/file/lib/service-table.utils';
import {
  applyCreatedOrdersToServices,
  applyOrderUpdateToServices
} from 'src/entities/order';
import {
  canShowOrderPdf,
  isOrderEditable as isOrderEditableFn
} from 'src/entities/order/model/order-status.model';
import { GraphService } from 'src/app/services/api/graph.service';

@Component({
  selector: 'app-detail-entradas',
  templateUrl: './detail-entradas.component.html',
  styleUrls: ['./detail-entradas.component.css']
})
export class DetailEntradasComponent implements OnInit {
  readonly hasServiceOrder = hasServiceOrder;
  readonly isOrderEditable = isOrderEditableFn;
  readonly canShowOrderPdf = canShowOrderPdf;

  selectedValue: string = '';
  dataItinial: FileModel[] = [];
  filtersSecction: boolean = false;
  loader: boolean = false;
  selectedFile: string | null = null;
  fileDataSource = new MatTableDataSource<FileModel>();
  estadoBtnMasivo: any = 0;
  messageButtonOS: any = null;
  model: any;
  resultOS: any;
  fileDisplayedColumns: string[] = [
    'Check',
    'fileNumber',
    'day',
    'nombreServicio',
    'categoriaServicio',
    'nombreProveedor',
    'tipoMoneda',
    'numOS',
    'numNP',
    'estadoOS',
    'numReserva',
    'estadoReserva',
    'correoReserva',
    'archivos',
    'verPDF'
  ];

  startDate: Date | any;
  endDate: Date | any;

  startDateSelected: Date | any;
  endDateSelected: Date | any;
  daySelected: string | null = null;
  selectFile: String | null = null;
  typeOfServiceSelected: String | null = null;
  categoriaOfServiceSelected: String | null = null;

  selectService: String | null = null;
  selectDate: String | null = null;
  selectNumOS: String | null = null;
  selectEstadoReserva: String | null = null;
  selectEstadoOS: string | null = null;

  selectEstadoFile: String | null = null;
  selectClient: String | null = null;
  selectNumberFile: String | null = null;
  filterValue: string = '';

  arrayDays: any[] | null = null;
  arrayFiles: any[] | null = null;
  arrayTypesOfService: any[] | null = null;
  arrayCategoriasOfService: any[] | null = null;

  arrayServices: any[] | null = null;
  arrayDates: any[] | null = null;
  arrayClients: any[] | null = null;
  arrayEstadoFile: any[] | null = null;
  arrayNumOS: any[] | null = null;
  arraySelectEstadoOS: any = [
    'CONFIRMADO',
    'EN PROCESO',
    'PAGADO',
    'CANCELADO',
    'ELIMINADO',
    'NOTACREDITO'
  ];

  toppingList: any[] | null = null;

  usuario: string = '';
  email: string = '';
  categoriasFiltradas: string[] = [];
  observacionOS: string = '';

  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    this.fileDataSource.paginator = value;
  }
  @ViewChild(MatSort) set sort(value: MatSort) {
    this.fileDataSource.sort = value;
  }

  constructor(
    private fileService: FileService,
    private changeDetectorRefs: ChangeDetectorRef,
    private router: Router,
    public loadingService: LoadingService,
    private functions: FunctionsService,
    private userService: CognitoService,
    private queryGQL: GraphService,
    public dialog: MatDialog,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    /*     this.userService.getAuthenticatedUser().then((data) => {
      this.usuario = `${data.attributes.middle_name} ${data.attributes.family_name}`;

      console.log('user', this.usuario);
      console.log('user', this.usuario);
    }); */

    this.usuario = `${localStorage.getItem('nombre')} ${localStorage.getItem(
      'apellido'
    )}`;

    this.email = `${localStorage.getItem('email')}`;

    console.log('user', this.usuario);
    console.log('email', this.email);

    this.arrayEstadoFile = [
      'APROBADO',
      'NO APROBADO',
      'NUEVO PEDIDO',
      'ANULADO',
      'POSTERGADO',
      'EN PROCESO',
      'CONFIRMADO',
      'RECONFIRMADO',
      'PROGRAMADO',
      'EN OPERACION',
      'OPERADO',
      'CERRADO'
    ];

    this.functions.disparadorCambios.subscribe((tipo: string) => {
      if (tipo === 'create-order') {
        return;
      }
      this.loadServices();
    });
    this.loadServices();

    this.showCustomStyleNotification();
  }

  showCustomStyleNotification() {
    const message = 'Mismo File,<br/>Misma Moneda,<br/>Mismo Proveedor';
    this.toastr.info(message, 'Requisitos para generar OS masivas', {
      enableHtml: true
    });
  }

  loadServices() {
    console.log('loadServices');
    this.loader = true;

    this.fileService.getAllEntradas().subscribe({
      next: (data) => {
        /*           console.log('DATA')
          console.log(data.getAllEntradas) */

        const allServicesFilterAventura = data.getAllEntradas.filter(
          (service: any) => service.tipoServicio == 'ENTRADA'
        );

        this.arrayDays = [
          ...new Set(allServicesFilterAventura.map((item: any) => item.day))
        ];
        this.arrayFiles = [
          ...new Set(
            allServicesFilterAventura.map((item: any) => item.fileNumber)
          )
        ];
        this.arrayTypesOfService = [
          ...new Set(
            allServicesFilterAventura.map((item: any) => item.tipoServicio)
          )
        ];
        this.arrayServices = [
          ...new Set(
            allServicesFilterAventura.map((item: any) => item.nombreServicio)
          )
        ];
        this.arrayDates = [
          ...new Set(allServicesFilterAventura.map((item: any) => item.date))
        ];
        this.arrayNumOS = [
          ...new Set(
            allServicesFilterAventura
              .map((item: any) => item.order?.orderNumber)
              .filter(Boolean)
          )
        ];

        this.arrayClients = [
          ...new Set(
            allServicesFilterAventura.map((item: any) => item.fileName)
          )
        ];

        // let data = dataServices;
        // this.dataItinial = data

        this.model = allServicesFilterAventura.map((item: any) => ({
          ...item,
          nombreProveedor: item.objProvider.nombre
        }));

        const typesOfService = [...new Set(this.arrayTypesOfService)];
        this.arrayCategoriasOfService = [];

        for (const tipo of typesOfService) {
          const categoriasSet = new Set();

          allServicesFilterAventura
            .filter((item: any) => item.tipoServicio === tipo)
            .forEach((item: any) => {
              categoriasSet.add(item.categoriaServicio);
            });

          const categorias = [...categoriasSet];

          this.arrayCategoriasOfService.push({ tipo, categorias });
        }
        const tipoSeleccionado = this.arrayCategoriasOfService?.find(
          (tipo) => tipo.tipo === 'ENTRADA'
        );
        this.categoriasFiltradas = tipoSeleccionado
          ? tipoSeleccionado.categorias
          : [];

        console.log('Services');
        console.log(
          'this.arrayCategoriasOfService',
          this.arrayCategoriasOfService
        );
        console.log(this.model);
        console.log('termino next');
        return allServicesFilterAventura;
      },
      complete: () => {
        this.model.map((fila: any) => {
          fila.checked = false;
        });
        this.fileDataSource = new MatTableDataSource(this.model);
        this.fileDataSource.paginator = this.paginator;
        this.fileDataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.loader = false;
        this.applyFilterSelect();
        this.applyFilter();
        console.log('termino complete');
      }
    });
  }

  sendEmailOS(numberOS: any) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query sendEmailOS($numberOS: String!){
        sendEmailOS(numberOS: $numberOS)
      }`,
      variables: { numberOS }
    });
  }

  async enviarOS(idOS: string, row: any, index: number) {
    this.fileService.sendEmailOS(idOS.toString()).subscribe({
      next: (data: any) => {
        console.log(data);
        if (data) {
          // this.fileDataSource.data[index].estadoReserva = "ENVIADO";
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Se envio correo',
            showConfirmButton: false,
            timer: 5000
          });
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Ocurrío un error',
            showConfirmButton: false,
            timer: 5000
          });
        }
      },

      error: () => {
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Ocurrío un error',
          showConfirmButton: false,
          timer: 5000
        });
      }
    });
  }

  openDialogPdfOS(id: any): void {
    const num = Number(id);

    let dialogRef = this.dialog.open(DialogPdfComponent, {
      width: '1300px',
      height: '1000px',
      data: { num }
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('The dialog was closed');
      // this.animal = result;
    });
  }

  applyFilter() {
    this.fileDataSource.filter = this.filterValue.trim().toLowerCase();
  }

  onGo(i: string) {
    this.router.navigate(['/file', i]);
  }
  addDaysToDate(date: any, days: any): any {
    var res = new Date(date);
    res.setDate(res.getDate() + days);
    return res;
  }

  traslateEstado(estado: String | null) {
    if (estado === 'SENT') {
      return 'ENVIADO';
    } else if (estado === 'CONFIRMED') {
      return 'CONFIRMADO';
    } else if (estado === 'DENIED') {
      return 'DENEGADO';
    } else if (estado === 'STANDBY') {
      return 'EN ESPERA';
    } else {
      return estado;
    }
  }

  transformDate(date: String, day: String) {
    const days = date.split('/')[0];
    const months = date.split('/')[1];
    const year = date.split('/')[2];

    var tmpDate = new Date(Number(year), Number(months), Number(days));
    const dateRpst = new Date(
      this.addDaysToDate(tmpDate, Number(Number(day) - 1))
    );
    // console.log(Date.UTC(Number(year), Number(months), Number(days)))
    const options: any = { year: 'numeric', month: 'numeric', day: 'numeric' };
    const formattedDate = dateRpst.toLocaleDateString(options);
    return formattedDate;
  }

  changeValue(tipoFile: string | null) {
    if (tipoFile) {
      this.selectedFile = tipoFile;
      this.fileDataSource.data = this.dataItinial.filter(
        (itemFilter) =>
          itemFilter.estadoFile ===
          (this.selectedFile === 'FILE' ? null : this.selectedFile)
      );
      console.log('list', this.fileDataSource.data);
    } else {
      this.fileDataSource.data = this.dataItinial;
      this.selectedFile = 'BORRAR';
    }
  }

  showFiltersFx() {
    this.filtersSecction = !this.filtersSecction;
    console.log(this.filtersSecction);
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.model.map((fila: any) => {
        fila.checked = false;
      });
      console.log(
        'verifica checked',
        this.model.filter((x: any) => x.checked == true)
      );
      this.estadoBtnMasivo = 0;
      return;
    } else {
      this.model.map((fila: any) => {
        fila.checked = !fila.checked;
      });
      console.log(
        'verifica checked',
        this.model.filter((x: any) => x.checked == true)
      );
      this.estadoBtnMasivo = this.model.length;
      return;
    }
  }

  isAllSelected() {
    let lstHoteles: any[];
    lstHoteles = this.fileDataSource.data.filter((x: any) => x.checked == true);
    const numSelected = lstHoteles.length;
    const numRows = this.fileDataSource.data.length;
    return numSelected === numRows;
  }

  updateCheck(row: any) {
    console.log('row', row);
    console.log(this.estadoBtnMasivo);
    row.checked = !row.checked;
    console.log('check model', this.model);
    // this.model[1].checked = true

    if (row.tipoServicio === 'GUIA' || row.tipoServicio === 'PERSONALDECAMPO') {
      this.model.forEach((servicio: any) => {
        if (
          servicio.fileNumber === row.fileNumber &&
          servicio.serviceId === row.serviceId &&
          servicio.providerId === row.providerId
        ) {
          servicio.checked = row.checked;
          console.log(servicio);
        }
      });
    }

    if (row.checked == true) {
      this.estadoBtnMasivo = Number(this.estadoBtnMasivo) + Number(1);
    } else {
      this.estadoBtnMasivo = Number(this.estadoBtnMasivo) - Number(1);
    }
    console.log(this.estadoBtnMasivo);
  }

  openDialogReservaManual(
    tipo: string,
    nombreServicio: string,
    idItinerary: string,
    idRegistro: string,
    nombreProveedor: string,
    editcode: boolean,
    service?: any
  ) {
    const dialogRef = this.functions.openDialogReservaManual(
      tipo,
      nombreServicio,
      idItinerary,
      idRegistro,
      nombreProveedor,
      'transportes',
      editcode,
      service?.order?.orderId,
      service
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.shouldRefresh) {
        this.functions.disparadorCambios.emit('reload-after-create-order');
        return;
      }

      if (!result?.success || !result.order) {
        return;
      }

      applyOrderUpdateToServices(this.model, result.orderNumber, result.order, service);
      this.applyFilterSelect();
    });
  }

  applyFilterSelect() {
    // console.log(this.toppings)
    // console.log(this.toppings.value)

    // console.log(this.selectedAgencia + '                ' + this.selectFile)
    // console.log(typeof this.selectedAgencia)
    let dataNew: any = this.model;
    console.log(dataNew);

    if (this.selectNumberFile) {
      console.log(this.selectNumberFile);
      dataNew = dataNew?.filter(
        (item: any) => item.fileNumber == this.selectNumberFile
      );
      // dataNew = dataNew?.filter((item: any) => this.toppings?.value?.includes(item.fileNumber))
    }

    if (this.daySelected) {
      dataNew = dataNew?.filter((item: any) => item.day === this.daySelected);
    }

    if (this.selectService) {
      dataNew = dataNew?.filter(
        (item: any) => item.nombreServicio === this.selectService
      );
    }
    if (this.typeOfServiceSelected) {
      dataNew = dataNew?.filter(
        (item: any) => item.tipoServicio === this.typeOfServiceSelected
      );
    }
    if (this.categoriaOfServiceSelected) {
      dataNew = dataNew?.filter(
        (item: any) =>
          item.categoriaServicio === this.categoriaOfServiceSelected
      );
    }
    if (this.selectDate) {
      dataNew = dataNew?.filter((item: any) => item.date === this.selectDate);
    }

    if (this.selectClient) {
      dataNew = dataNew?.filter(
        (item: any) => item.fileName === this.selectClient
      );
    }

    if (this.selectNumOS) {
      dataNew = dataNew?.filter(
        (item: any) => item.order?.orderNumber === this.selectNumOS
      );
    }

    if (this.selectEstadoOS) {
      dataNew = dataNew?.filter(
        (item: any) => item.order?.orderStatus === this.selectEstadoOS
      );
    }
    if (this.selectEstadoFile) {
      dataNew = dataNew?.filter(
        (item: any) => item.estadoFile === this.selectEstadoFile
      );
    }

    if (this.startDateSelected && this.endDateSelected) {
      console.log(this.startDateSelected);
      console.log(dataNew[0].date);
      console.log(dataNew[0].dateToShow);
      console.log(moment(dataNew[0].date, 'MM.DD.YYYY').toDate());
      dataNew = dataNew?.filter(
        (item: any) =>
          new Date(this.startDateSelected) <=
            moment(item.dateToShow, 'DD.MM.YYYY').toDate() &&
          moment(item.dateToShow, 'DD.MM.YYYY').toDate() <=
            new Date(this.endDateSelected)
      );

      console.log(
        new Date(this.startDateSelected),
        new Date(this.endDateSelected)
      );
    }

    console.log(dataNew);
    this.fileDataSource.data = dataNew;
  }
  transformDay(range: String, toDay: number) {
    const firstDate = range?.split('-')?.[0]?.trim();
    console.log(firstDate);
    const days = firstDate.split('/')[0];
    const months = firstDate.split('/')[1];
    const year = firstDate.split('/')[2];

    console.log(months + '/' + days + '/' + year);

    var result = new Date(months + '/' + days + '/' + year);
    result.setDate(result.getDate() - toDay);
    console.log(result);
    return result.toString();
  }

  transformDateShow(range: String) {
    const firstDate = range?.split('-')?.[0]?.trim();
    console.log(firstDate);
    const days = firstDate.split('/')[0];
    const months = firstDate.split('/')[1];
    const year = firstDate.split('/')[2];

    console.log(months + '/' + days + '/' + year);

    var result = new Date(months + '/' + days + '/' + year);

    return result.toString();
  }

  async sendReservaOS(): Promise<any> {
    const serviceIds = [
      ...new Set(
        (this.model ?? [])
          .filter((fila: any) => fila.checked && !hasServiceOrder(fila))
          .map((s: any) => s.id)
          .filter(Boolean)
      )
    ] as string[];
    if (!serviceIds.length) return;

    const operationDates = (this.model ?? [])
      .filter((fila: any) => fila.checked && !hasServiceOrder(fila))
      .map((s: any) => s.startDateService ?? s.serviceDate ?? null);

    const dialogRef = this.functions.openCreateOrderDialog({
      serviceIds,
      operationDates,
      contextLabel: 'Entradas'
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result) {
        return;
      }

      if (result.shouldRefresh) {
        this.estadoBtnMasivo = 0;
        this.loadServices();
        return;
      }

      if (result.success) {
        applyCreatedOrdersToServices(
          this.model ?? [],
          result.result?.createdOrders,
          'id',
          result.submittedInput
        );
        this.estadoBtnMasivo = 0;
        this.applyFilterSelect();
      }
    });
  }

  onApplyRangeSelected() {
    console.log(this.startDate);

    console.log({
      start: this.getDateTransform(JSON.stringify(new Date(this.startDate))),
      end: this.getDateTransform(JSON.stringify(new Date(this.endDate)))
    });
    this.startDateSelected = this.getDateTransform(
      JSON.stringify(new Date(this.startDate))
    );
    this.endDateSelected = this.getDateTransform(
      JSON.stringify(new Date(this.endDate))
    );
    this.applyFilterSelect();
  }

  getDateTransform(date: string) {
    const dateSeparated = date.slice(1, 11).split('-');
    const month = dateSeparated[1];
    const day = dateSeparated[2];
    const year = dateSeparated[0];
    return month + '/' + day + '/' + year;
  }

  cleanDateSelected() {
    this.startDate = null;
    this.startDateSelected = null;
    this.endDate = null;
    this.endDateSelected = null;

    this.applyFilterSelect();
  }

  openDialog(element: any) {
    console.log(element);
    let dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      fileId: element.fileNumber,
      serviceType: 1,
      serviceName: element.nombreServicio,
      serviceId: element.serviceId,
      hasDocument: element.hasDocument
    };
    dialogConfig.width = '1000px';
    dialogConfig.minHeight = '379px';
    dialogConfig.maxHeight = '900px';

    let dialogRef = this.dialog.open(
      DialogArchivosReservasComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        element.hasDocument = result.changeIconColor;
      }
    });
  }
}
